// import React from "react";
import { Modal, Button, Image, Row, Col } from "react-bootstrap";
import { useCartWishlist } from "../context/CartWishlistContext";

const WishListModal = ({
  show,
  handleClose,
  // wishList = [],
  // removeItemtoWishlist,
}) => {
  const { wishList, removeItemtoWishlist } = useCartWishlist();

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      style={{ backdropFilter: "blur(3px)" }}
    >
      <Modal.Header closeButton>
        <Modal.Title>My wishList ❤️</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {wishList.length === 0 ? (
          <div
            style={{
              minHeight: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p className="text-muted">Your wishList is empty.</p>
          </div>
        ) : (
          <div className="wishList-items-wrapper">
            {wishList.map((item) => (
              <Row
                key={item._id}
                className="align-items-center mb-3 border-bottom pb-2"
              >
                <Col xs={3} className="text-center">
                  <Image
                    src={item.product?.imageUrl || "/img/product/1.jpg"}
                    alt={item.product?.title}
                    width={70}
                    height={70}
                    rounded
                    style={{ objectFit: "cover" }}
                  />
                </Col>
                <Col xs={7}>
                  <div className="fw-semibold mb-1">{item.product?.title}</div>
                  <div className="text-muted small">{item.product?.brand}</div>
                  <div className="text-success fw-semibold">
                    Rs {item.product?.originalPrice}
                  </div>
                </Col>
                <Col xs={2} className="text-end">
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeItemtoWishlist(item.product?._id)}
                  >
                    <i className="bi bi-trash" />
                  </Button>
                </Col>
              </Row>
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default WishListModal;
